<template>
  <div class="nft-type-filter-comp">
    <div class="tab-list">
      <div
          v-for="(filter, index) in filterList"
          :key="index"
          class="tab-item cursor-pointer"
          @click="updateSelected(filter.value)"
      >
        <mv-tab
            :content="filter"
            :selected="selected === filter.value"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import MvTab from '@/components/common/tab/MvTab.vue';
import {useHomeListCtgyConfig} from '@/script/homeScript';

export default defineComponent({
  name: 'NftTypeFilterComp',
  components: {
    MvTab,
  },
  emits: ['update:selected'],
  props: {
    selected: {
      default: "",
    },
  },
  setup(props, context) {
    const {
      changeCtgy,
      nftCtgy,
    } = useHomeListCtgyConfig()
    const filterList = [
      {
        label: 'nftType.all',
        value: ''
      },
      {
        label: 'nftType.MEMBERSHIP',
        value: 'MEMBERSHIP',
      },
      {
        label: 'nftType.TICKET',
        value: 'TICKET',
      },
    ]

    const updateSelected = (value: string) => {
      context.emit('update:selected', value)
    }

    return {
      filterList,
      nftCtgy,
      changeCtgy,
      updateSelected,
    }
  }
})
</script>
